"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

require("core-js/modules/es.object.get-prototype-of.js");

require("core-js/modules/es.reflect.construct.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

var _ecc = require("./ecc");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function toWif(key) {
  return key.toWif ? key.toWif() : key;
}

;

var Session =
/*#__PURE__*/
function () {
  function Session() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'autopost2';

    _classCallCheck(this, Session); // key is compatible with Golos UI


    this.key = key;
  }

  _createClass(Session, [{
    key: "ensure",
    value: function ensure() {
      if (typeof localStorage === 'undefined') throw new Error('Browser should support localStorage.');
    }
  }, {
    key: "save",
    value: function save(username, postingKey, memoKey, loginOwnerPubKey) {
      this.ensure();
      memoKey = memoKey ? toWif(memoKey) : '';
      loginOwnerPubKey = loginOwnerPubKey || '';
      var data = new Buffer("".concat(username, "\t").concat(toWif(postingKey), "\t").concat(memoKey, "\t").concat(loginOwnerPubKey)).toString('hex');
      localStorage.setItem(this.key, data);
    }
  }, {
    key: "load",
    value: function load() {
      this.ensure();
      var data = localStorage.getItem(this.key);

      if (data) {
        return new Buffer(data, 'hex').toString().split('\t');
      }

      return null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.ensure();
      localStorage.removeItem(this.key);
    }
  }]);

  return Session;
}();

var PageSession =
/*#__PURE__*/
function (_Session) {
  _inherits(PageSession, _Session);

  var _super = _createSuper(PageSession);

  function PageSession() {
    var _this;

    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'session_id';

    _classCallCheck(this, PageSession);

    _this = _super.call(this);
    _this.key = key;
    return _this;
  }

  _createClass(PageSession, [{
    key: "ensure",
    value: function ensure() {
      if (typeof sessionStorage === 'undefined') throw new Error('Browser should support sessionStorage.');
    }
  }, {
    key: "save",
    value: function save(password, username) {
      var authType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'active';
      this.ensure();

      try {
        _ecc.PrivateKey.fromWif(password);
      } catch (e) {
        password = _ecc.PrivateKey.fromSeed(username + authType + password).toString();
      }

      var data = Date.now().toString() + '\t' + new Buffer(password).toString('hex');
      sessionStorage.setItem(this.key, data);
    }
  }, {
    key: "load",
    value: function load() {
      this.ensure();
      var saved = sessionStorage.getItem(this.key);

      if (saved) {
        var arr = saved.split('\t');
        arr[0] = parseInt(arr[0]);
        arr[1] = new Buffer(arr[1], 'hex').toString();
        return arr;
      }

      return null;
    }
  }, {
    key: "clear",
    value: function clear() {
      this.ensure();
      sessionStorage.removeItem(this.key);
    }
  }]);

  return PageSession;
}(Session);

module.exports = {
  session: new Session(),
  Session: Session,
  pageSession: new PageSession(),
  PageSession: PageSession
};